<div class="announcement-stats-and-reports">
  <h3>{{ 'label.Announcements' | translate }}</h3>
  <br />
  <div class="content">
    <div>
      <div>{{ 'label.CurrentActive' | translate }}:</div>
      <div>
        {{
          channelAnnouncementStats && channelAnnouncementStats[0]?.totalCount
        }}
      </div>
    </div>
    <div>
      <div>{{ 'label.CurrentActiveUnique' | translate }}:</div>
      <div>
        {{
          channelAnnouncementStats && channelAnnouncementStats[0]?.uniqueCount
        }}
      </div>
    </div>
    <div *ngFor="let item of channelAnnouncementStats">
      <div>
        {{ 'label.CurrentActive' | translate }} {{ item?.channel?.name }}:
      </div>
      <div>{{ item?.countPerChannel }}</div>
    </div>
    <div>
      <div>{{ 'label.ForStudentActiveAnnouncements' | translate }}:</div>
      <div>
        {{
          channelAnnouncementStats &&
            channelAnnouncementStats[0]?.suitableForStudentsAnnouncementsCount
        }}
      </div>
    </div>
  </div>
  <br />
  <div>
    <div>{{ 'label.Reports' | translate }}:</div>
    <div style="margin-top: 1em">
      <a [routerLink]="['/stats-and-reports/announcements-totals-per-customer']"
        >Announcements Totals Per Customer</a
      >
    </div>
  </div>
</div>
